import styled from "styled-components";

import { Link } from "react-router-dom";

import { theme } from "../../../../styles/theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
`;

export const SubTitle = styled.h3`
  margin-top: 32px;
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.light};
  color: ${theme.colors.blue100};
  text-align: center;
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};
  margin-top: 8px;
  text-align: center;
`;

const StyledLink = styled(Link)`
  font-family: ${theme.font.poppins};
  font-weight: ${theme.font.normal};
  font-size: ${theme.font.sizes.normal};
  width: 100%;
  text-align: center;
  text-decoration: none;
  margin-top: 20px;
`;

export const RegisterLink = styled(StyledLink)`
  color: ${theme.colors.blue100};

  span {
    text-decoration: underline;
  }
`;

export const TermsLink = styled(StyledLink)`
  color: ${theme.colors.gray400};
`;

export const Img = styled.img`
  width: 300px;
  margin: 0 auto;
`;

export const Button = styled(Link)`
  width: 100%;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  background-color: ${theme.colors.blue100};
  margin-top: 20px;
  border-radius: ${theme.border.mediumRadius};
  border: none;

  font-family: ${theme.font.poppins};
  color: ${theme.colors.blue900};
  font-weight: ${theme.font.semiBold};
  font-size: ${theme.font.sizes.normal};
  font-style: normal;

  &:hover {
    color: ${theme.colors.darkBlue};
  }
`;
